import DriverScreen from './index';

const routes = [
  {
    path: '/onboarding-driver',
    component: DriverScreen,
  },
];

export default routes;
